export default __webpack_public_path__ + "static/media/bachho.439aa81d.png";